if (!customElements.get('mobile-dock')) {
  customElements.define(
    'mobile-dock',
    class MobileDock extends HTMLElement {
      constructor() {
        super();
    
        if (Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get section() {
        return this._section = this._section || this.closest('.mobile-dock-section');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        this.setAttribute('loaded', '');
    
        this.detectForHeader();
        this.detectForFooter();
        setTimeout(this.setHeight.bind(this));
        document.addEventListener('matchSmall', this.setHeight.bind(this));
    
        if (Shopify.designMode) {
          this.section.addEventListener('shopify:section:select', () => {
            this.section.classList.add('shopify-active');
          });
          this.section.addEventListener('shopify:section:deselect', () => {
            this.section.classList.remove('shopify-active');
          });
        }
      }
    
      detectForHeader() {
        const header = document.querySelector('.header-section');
        if (header === null) {
          this.section.classList.add('active');
          return;
        }
        
        if (!header.classList.contains('header-sticky')) {
          this.scrollY  = parseInt(header.getBoundingClientRect().bottom);
          window.addEventListener('scroll', theme.utils.throttle(this.onScrollForHeader.bind(this)), false);
        }
      }
    
      onScrollForHeader() {
        if (window.scrollY >= this.scrollY) {
          this.section.classList.add('active');
        }
        else {
          this.section.classList.remove('active');
        }
      }
    
      detectForFooter() {
        const footer = document.querySelector('.footer-copyright');
        if (footer === null) return;

        if (!('IntersectionObserver' in window)) return;

        this.footerObserver = new IntersectionObserver((entries) => {
          const isFooterVisible = entries.some((entry) => entry.isIntersecting);
          this.classList.toggle('active', theme.config.mqlSmall && isFooterVisible);
        }, {
          rootMargin: `0px 0px -${this.offsetHeight || 0}px 0px`
        });
        this.footerObserver.observe(footer);
      }
    
      setHeight() {
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
      }
    }, { extends: 'nav' }
  );
}
